import type { OperationsStartRiskKey } from "@/api/endpoints";
import { fmtDateOnly } from "@/lib/format";
import { START_RISK_CLASS, START_RISK_LABEL, startLeadLabel } from "../operationsLabels";

interface CellProps {
  risk: OperationsStartRiskKey;
  leadBd: number | null;
}

/**
 * The work-order version's start date with, under it, the plain lead ("in 4 bd") or the At risk / Breached
 * pill when flagged (2026-10-26: the pill lives here, no separate Flag column). "—" when the rule does not apply.
 */
export function StartDateCell({ risk, leadBd, startDate, hidePill = false }: CellProps & { startDate: string | null; hidePill?: boolean }) {
  if (risk === "none" || !startDate) {
    return <td className="fit start muted" title="No work order, no version start date, approved, or a type the rule does not cover.">—</td>;
  }
  const flagged = risk === "atRisk" || risk === "breached";
  return (
    <td className={`fit start risk-${START_RISK_CLASS[risk]}`}>
      <span className="nowrap">{fmtDateOnly(startDate)}</span>
      {flagged && !hidePill ? <StartRiskPill risk={risk} leadBd={leadBd} /> : <span className="lead">{startLeadLabel(leadBd)}</span>}
    </td>
  );
}

export function StartRiskPill({ risk, leadBd, short = false }: CellProps & { short?: boolean }) {
  if (risk !== "atRisk" && risk !== "breached") return <span className="muted">—</span>;
  const lead = startLeadLabel(leadBd);
  return (
    <span className={`ops-pill risk-${START_RISK_CLASS[risk]}`} data-testid="start-risk-pill">
      <span className="material-symbols-rounded" aria-hidden="true">{risk === "breached" ? "event_busy" : "schedule"}</span>
      {START_RISK_LABEL[risk]}
      {!short && lead && <span className="lead"> · {lead === "starts today" ? "today" : lead}</span>}
    </span>
  );
}
